import AddDocFirmatoController from "./add_doc_firmato/AddDocFirmatoController";
import React, {useContext, useEffect, useState} from "react";
import DocFirmatoController from "./show_doc_firmato/DocFirmatoController";
import axios from "axios";
import {LoaderContext} from "../../../../context/LoaderContext";

export default function DocFirmatoContainerController({
                                                          idCertificato
                                                      }) {

    const [documento, setDocumento] = useState();

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function getDocumentoFirmato() {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/documento-firmato/`)
            .then((response) => {
                setDocumento(response.data.data)
                endChiamata()
            });
    }

    useEffect(() => {
        getDocumentoFirmato();
    }, [idCertificato]);

    return (
        documento ?
            <DocFirmatoController
                documento={documento}
                onUpdate={getDocumentoFirmato}
            />
            :
            <AddDocFirmatoController
                idCertificato={idCertificato}
                submitOk={getDocumentoFirmato}
            />
    );

}